import React from 'react';
import { RcSubCollapseProvider, useCreateSubCollapse } from '../../hooks/collapse';
import { classnames } from '@bydesign-ui/utils';
import { usePrefixCls } from '@byte-design/config';
export function SubCollapse(props) {
  var className = props.className,
      children = props.children,
      type = props.type,
      id = props.id;
  var cls = classnames(usePrefixCls('claps', {
    type: type
  }), className);

  var _useCreateSubCollapse = useCreateSubCollapse({
    id: id
  }),
      subCollapse = _useCreateSubCollapse.subCollapse;

  return React.createElement(RcSubCollapseProvider, {
    subCollapse: subCollapse
  }, React.createElement("div", {
    className: cls
  }, children));
}